import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Library, OPTIONS } from '../library';

@Injectable({
  providedIn: 'root'
})
export class HolidayService {

  constructor(private http: HttpClient) { }

  createUpdateHoliday(holidayForm: any) {
    return this.http.post<any>(Library.API_ENDPOINT + 'holiday/save_update_holiday', holidayForm, OPTIONS);
  }

  getHolidays() {
    return this.http.get<any>(Library.API_ENDPOINT + 'holiday/get_holidays', OPTIONS);
  }

  deleteHoliday(id: number) {
    return this.http.post<any>(Library.API_ENDPOINT + `holiday/delete_holiday/${id}`, OPTIONS);
  }

  getHolidayCategories() {
    return this.http.get<any>(Library.API_ENDPOINT + 'holiday/get_holiday_categories', OPTIONS);
  }
}
